// removed by extract-text-webpack-plugin
module.exports = {"block":"CompilationDescription__block-1S3-a"};